(() => {
  if (window.FermorinEstimatedDelivery) return;

  const descriptionSelector = 'delivery-preview-description.essential-estimated-delivery-description';
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const observedTimers = new WeakSet();
  let refreshFrame;

  function parseDeliveryDate(value) {
    const match = String(value || '').trim().match(/^(\d{1,2})\/(\d{1,2})(?:\/(\d{2,4}))?$/);
    if (!match) return null;

    const day = Number(match[1]);
    const month = Number(match[2]);
    let year = match[3] ? Number(match[3]) : null;

    if (year !== null && year < 100) year += 2000;
    if (day < 1 || day > 31 || month < 1 || month > 12) return null;

    return { day, month, year };
  }

  function inferStartYear(date) {
    if (date.year !== null) return date.year;

    const now = new Date();
    const currentMonth = now.getMonth() + 1;
    let year = now.getFullYear();

    if (date.month < currentMonth - 6) year += 1;

    return year;
  }

  function formatDeliveryRange(fromValue, toValue) {
    const from = parseDeliveryDate(fromValue);
    const to = parseDeliveryDate(toValue);
    if (!from || !to) return '';

    const fromYear = inferStartYear(from);
    let toYear = to.year === null ? fromYear : to.year;

    if (to.year === null && (to.month < from.month || (to.month === from.month && to.day < from.day))) {
      toYear += 1;
    }

    if (fromYear !== toYear) {
      return `${monthNames[from.month - 1]} ${from.day}, ${fromYear}–${monthNames[to.month - 1]} ${to.day}, ${toYear}`;
    }

    if (from.month !== to.month) {
      return `${monthNames[from.month - 1]} ${from.day}–${monthNames[to.month - 1]} ${to.day}`;
    }

    return `${monthNames[from.month - 1]} ${from.day}–${to.day}`;
  }

  function fallbackDeliveryRange(description) {
    const timelineValue = description
      .closest('delivery-preview-widget')
      ?.querySelector('.essential-estimated-delivery-sub-title-3')
      ?.textContent
      ?.trim();

    return timelineValue ? timelineValue.replace(/\s+-\s+/g, '–') : '';
  }

  function formatCountdown(timer) {
    const match = String(timer?.textContent || '').match(
      /(\d{1,3})\s*(?::|h(?:r|ours?)?)\s*(\d{1,2})\s*(?:m(?:in(?:utes?)?)?)?/i
    );
    if (!match) return '';

    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (hours > 0) return `${hours} hr ${minutes} min`;
    return `${minutes} min`;
  }

  function observeTimer(timer, description) {
    if (!timer || observedTimers.has(timer)) return;

    observedTimers.add(timer);
    new MutationObserver(() => enhanceDescription(description)).observe(timer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function enhanceDescription(description) {
    if (!description.isConnected) return;

    const timer = description.querySelector('timer-display.essential-estimated-delivery-counter');
    const fromValue = description.querySelector('.essential-estimated-delivery-delivery_from')?.textContent;
    const toValue = description.querySelector('.essential-estimated-delivery-delivery_to')?.textContent;
    const countdown = formatCountdown(timer);
    const deliveryRange = formatDeliveryRange(fromValue, toValue) || fallbackDeliveryRange(description);

    observeTimer(timer, description);
    if (!countdown || !deliveryRange) return;

    let replacement = description.querySelector(':scope > .fermorin-estimated-delivery-copy');
    if (!replacement) {
      replacement = document.createElement('span');
      replacement.className = 'fermorin-estimated-delivery-copy';
      replacement.setAttribute('role', 'status');
      replacement.style.cssText = 'display:block;width:100%;line-height:1.45;';
      description.appendChild(replacement);
    }

    Array.from(description.children).forEach((child) => {
      if (child === replacement || child.dataset.fermorinDeliveryHidden === 'true') return;
      child.dataset.fermorinDeliveryHidden = 'true';
      child.setAttribute('aria-hidden', 'true');
      child.style.setProperty('display', 'none', 'important');
    });

    const copy = `🕚 Order within ${countdown} for estimated delivery ${deliveryRange}.`;
    if (replacement.textContent !== copy) replacement.textContent = copy;
  }

  function refreshAll() {
    document.querySelectorAll(descriptionSelector).forEach(enhanceDescription);
  }

  function scheduleRefresh(records) {
    if (
      records?.length &&
      records.every((record) => record.target instanceof Element && record.target.closest('.fermorin-estimated-delivery-copy'))
    ) {
      return;
    }

    if (refreshFrame) return;
    refreshFrame = requestAnimationFrame(() => {
      refreshFrame = null;
      refreshAll();
    });
  }

  const observer = new MutationObserver(scheduleRefresh);
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scheduleRefresh);

  window.FermorinEstimatedDelivery = { refresh: refreshAll };
  scheduleRefresh();
})();
